import React from 'react'
import { Modal } from 'react-bootstrap'

export function QuizEditDialogHeader() {
	return (
		<>
			<Modal.Header>
				<div className='container' style={{ padding: 0 }}>
					<Modal.Title id='example-modal-sizes-title-lg'>Create</Modal.Title>
				</div>
			</Modal.Header>
		</>
	)
}
